module.exports = __webpack_public_path__ + "static/47gde-444fb2b21d44b9de4525a44a5c0f810e.gif";